import { PropsWithChildren } from "react";

export const SidebarBody = ({ children }: PropsWithChildren<{}>) => (
  <div className="flex flex-col flex-grow w-full overflow-auto">{children}</div>
);
